/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  JiaoSeBianJiDTO,
  JiaoSeChuangJianDTO,
  OperationQueryDTO,
  ResponseApiBoolean,
  ResponseApiIPageOperationListRespDTO,
  ResponseApiListJiaoSeLieBiaoXinXi,
  ResponseApiListJiaoSeXinXi,
  ResponseApiListJiaoSeYongHuXinXi,
  ResponseApiListLong,
  ResponseApiLong,
  ResponseApiOperationCreateRespDTO,
  YunYingRenYuanMiMaGengXin,
  YunYingRenYuanYongHuXinXi,
  YunYingRenYuanZhuangTaiGengXin,
} from "./data-contracts";
import { HttpClient, RequestParams, ContentType } from '@gatherstar/utils';

export class YunYingHouTaiYongHuJiaoSeGuanLi<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags YunYingHouTaiYongHuJiaoSeGuanLi
   * @name GetOperatorListUsingPost
   * @summary 获取运营人员列表
   * @request POST:/dsp-admin/api/role-user/list
   * @secure
   */
  getOperatorListUsingPost = (
    queryDTO: OperationQueryDTO,
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiIPageOperationListRespDTO, void>({
      path: `/dsp-admin/api/role-user/list`,
      method: "POST",
      body: queryDTO,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags YunYingHouTaiYongHuJiaoSeGuanLi
   * @name CreateRoleUsingPost
   * @summary 新增角色
   * @request POST:/dsp-admin/api/role-user/role/create
   * @secure
   */
  createRoleUsingPost = (
    roleCreateDTO: JiaoSeChuangJianDTO,
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiLong, void>({
      path: `/dsp-admin/api/role-user/role/create`,
      method: "POST",
      body: roleCreateDTO,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags YunYingHouTaiYongHuJiaoSeGuanLi
   * @name GetRoleListWithUsersUsingPost
   * @summary 获取角色列表（包含人员名单）
   * @request POST:/dsp-admin/api/role-user/role/list
   * @secure
   */
  getRoleListWithUsersUsingPost = (params: RequestParams = {}) =>
    this.request<ResponseApiListJiaoSeLieBiaoXinXi, void>({
      path: `/dsp-admin/api/role-user/role/list`,
      method: "POST",
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags YunYingHouTaiYongHuJiaoSeGuanLi
   * @name UpdateRoleUsingPut
   * @summary 编辑角色
   * @request PUT:/dsp-admin/api/role-user/role/{roleId}
   * @secure
   */
  updateRoleUsingPut = (
    roleUpdateDTO: JiaoSeBianJiDTO,
    roleId?: number,
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiBoolean, void>({
      path: `/dsp-admin/api/role-user/role/${roleId}`,
      method: "PUT",
      body: roleUpdateDTO,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags YunYingHouTaiYongHuJiaoSeGuanLi
   * @name GetRoleMenuIdsUsingPost
   * @summary 获取角色的菜单权限
   * @request POST:/dsp-admin/api/role-user/role/{roleId}/menus
   * @secure
   */
  getRoleMenuIdsUsingPost = (roleId?: number, params: RequestParams = {}) =>
    this.request<ResponseApiListLong, void>({
      path: `/dsp-admin/api/role-user/role/${roleId}/menus`,
      method: "POST",
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags YunYingHouTaiYongHuJiaoSeGuanLi
   * @name RemoveUserFromRoleUsingDelete
   * @summary 从角色中删除成员
   * @request DELETE:/dsp-admin/api/role-user/role/{roleId}/user/{userId}
   * @secure
   */
  removeUserFromRoleUsingDelete = (
    roleId?: number,
    userId?: number,
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiBoolean, void>({
      path: `/dsp-admin/api/role-user/role/${roleId}/user/${userId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags YunYingHouTaiYongHuJiaoSeGuanLi
   * @name GetEnabledRolesUsingGet
   * @summary 获取所有启用的角色列表
   * @request GET:/dsp-admin/api/role-user/roles
   * @secure
   */
  getEnabledRolesUsingGet = (params: RequestParams = {}) =>
    this.request<ResponseApiListJiaoSeXinXi, void>({
      path: `/dsp-admin/api/role-user/roles`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags YunYingHouTaiYongHuJiaoSeGuanLi
   * @name AddOperatorUsingPost
   * @summary 新增运营人员
   * @request POST:/dsp-admin/api/role-user/user/create
   * @secure
   */
  addOperatorUsingPost = (
    userDTO: YunYingRenYuanYongHuXinXi,
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiOperationCreateRespDTO, void>({
      path: `/dsp-admin/api/role-user/user/create`,
      method: "POST",
      body: userDTO,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags YunYingHouTaiYongHuJiaoSeGuanLi
   * @name UpdateOperatorUsingPut
   * @summary 编辑运营人员
   * @request PUT:/dsp-admin/api/role-user/user/{id}
   * @secure
   */
  updateOperatorUsingPut = (
    id: number,
    userDTO: YunYingRenYuanYongHuXinXi,
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiBoolean, void>({
      path: `/dsp-admin/api/role-user/user/${id}`,
      method: "PUT",
      body: userDTO,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags YunYingHouTaiYongHuJiaoSeGuanLi
   * @name GetUsersByRoleKeyUsingGet
   * @summary 根据角色名称获取用户ID和用户名列表
   * @request GET:/dsp-admin/api/role-user/users-by-role-key
   * @secure
   */
  getUsersByRoleKeyUsingGet = (
    query?: {
      /** 角色名称 */
      roleKey?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiListJiaoSeYongHuXinXi, void>({
      path: `/dsp-admin/api/role-user/users-by-role-key`,
      method: "GET",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags YunYingHouTaiYongHuJiaoSeGuanLi
   * @name UpdateOperatorStatusUsingPut
   * @summary 修改运营人员状态
   * @request PUT:/dsp-admin/api/role-user/{id}/status
   * @secure
   */
  updateOperatorStatusUsingPut = (
    statusUpdateDTO: YunYingRenYuanZhuangTaiGengXin,
    id?: number,
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiBoolean, void>({
      path: `/dsp-admin/api/role-user/${id}/status`,
      method: "PUT",
      body: statusUpdateDTO,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags YunYingHouTaiYongHuJiaoSeGuanLi
   * @name UpdatePasswordUsingPut
   * @summary 修改运营人员密码
   * @request PUT:/dsp-admin/api/role-user/{id}/update-password
   * @secure
   */
  updatePasswordUsingPut = (
    passwordUpdateDTO: YunYingRenYuanMiMaGengXin,
    id?: number,
    params: RequestParams = {},
  ) =>
    this.request<ResponseApiBoolean, void>({
      path: `/dsp-admin/api/role-user/${id}/update-password`,
      method: "PUT",
      body: passwordUpdateDTO,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
}


// 导出默认实例，可直接使用
export const api = new YunYingHouTaiYongHuJiaoSeGuanLi();
